import { createFileRoute, redirect } from '@tanstack/react-router';
import { featuresOptions } from '@/hooks/query-options';
import { hasPermission } from '@/lib/permissions';
import { IntegrationOverview } from '@/components/integrations-hub/integration-overview';

export const Route = createFileRoute(
  '/_auth/_side-layout/integrations/$integrationId',
)({
  component: IntegrationOverviewPage,
  beforeLoad: async ({ context }) => {
    // Direct-URL guard mirroring the nav's `integrations` flag gate.
    const features =
      await context.queryClient.ensureQueryData(featuresOptions());
    if (
      features.integrationsHub !== true ||
      !hasPermission(context.userRole, { organization: ['update'] })
    ) {
      throw redirect({ to: '/integrations/access' });
    }
  },
});

function IntegrationOverviewPage() {
  const { integrationId } = Route.useParams();
  return (
    <IntegrationOverview key={integrationId} integrationId={integrationId} />
  );
}
